import { useEffect, useRef } from 'react';
import { user } from 'src/api/user/user';
import {
  clearObservedPwaInstallation,
  hasObservedPwaInstallation,
  isPwaStandalone,
  markPwaInstallationObserved,
} from 'src/pwa/pwa';

const PwaInstallTracking = () => {
  const requestInFlightRef = useRef(false);

  useEffect(() => {
    const recordInstallation = async () => {
      if (requestInFlightRef.current || (!isPwaStandalone() && !hasObservedPwaInstallation())) {
        return;
      }

      requestInFlightRef.current = true;

      try {
        await user.recordPwaInstallation();
        clearObservedPwaInstallation();
      } catch (error) {
        console.error('Failed to record the PWA installation:', error);
      } finally {
        requestInFlightRef.current = false;
      }
    };

    const handleAppInstalled = () => {
      markPwaInstallationObserved();
      void recordInstallation();
    };
    const retryInstallationRecord = () => {
      void recordInstallation();
    };

    if (isPwaStandalone()) {
      markPwaInstallationObserved();
    }

    void recordInstallation();
    window.addEventListener('appinstalled', handleAppInstalled);
    window.addEventListener('online', retryInstallationRecord);

    return () => {
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('online', retryInstallationRecord);
    };
  }, []);

  return null;
};

export default PwaInstallTracking;
